import { routes } from 'commons/constants/routes'
import { Request } from 'commons/utils/request'
import { ButtonGroup, Link } from 'ui/components'
import { Button } from 'ui/components/Buttons'
import { ExportCSVButton } from 'ui/temp/ExportCSVButton'
import { useTemplatesListContext } from '~bank-document-templates/list/context'

export const Actions = () => {
  const { data } = useTemplatesListContext()
  const { canAddNew, form } = data

  return (
    <ButtonGroup margin="small">
      <ExportCSVButton reportName="User" url={Request.urls.bank.documentTemplateExportCSV} parametersForm={form} />
      {canAddNew && (
        <Link to={routes.bank.documentTemplates.manage} params={{ id: '0' }} data-qa="Create Template">
          <Button face="tertiary">Create Template</Button>
        </Link>
      )}
    </ButtonGroup>
  )
}
